import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { hazardMaster } from '../../Models/HazardMasterModel';
import { inductryMaster } from '../../Models/InductryMasterModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../../Models/ResultModel';

@Injectable()
export class AdminHazardMasterServices {

    apiURL: string = "";
    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
            this.apiURL = sessionStorage.getItem("BaseURL") || '';
            this.apiURL = this.apiURL + 'api/HazardMasterAdmin';
        }
    }

    GetHazardMaster(TokenKey: string, pageIndex: string, pageSize: string, whereCondition: string, orderBy: string): Observable<hazardMaster[]> {
        let data = "/" + pageIndex + "/" + pageSize + "/" + whereCondition + "/" + orderBy;
        let fullAPIPath = this.apiURL + '/GetHazardMasterFilterByPage' + data;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<hazardMaster[]>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetHazardMasterFindByMultipleInductry(TokenKey: string, HazardMasterId: string): Observable<inductryMaster[]> {
        let data = "/" + HazardMasterId;
        let fullAPIPath = this.apiURL + '/GetHazardMasterFindByMultipleInductry' + data;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<inductryMaster[]>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    AddUpdateHazardMaster(TokenKey: string, listObj: any, HazardName: string, isActive: string, CreatedBy: string, HazardMasterId: string): Observable<number> {    
        let fullAPIPath = this.apiURL + '/AddHazardMaster';
        const formData = new FormData();
        formData.append('listObj',listObj);
        formData.append('HazardName', HazardName);
        formData.append('isActive', isActive);
        formData.append('CreatedBy', CreatedBy);
        formData.append('HazardMasterId', HazardMasterId);
        formData.append('Token', TokenKey);        
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.post<number>(fullAPIPath, formData)
            .pipe(catchError(this.handleError));
    }

    DeleteHazardMaster(TokenKey: string, HazardMasterId: string): Observable<number> {    
        let fullAPIPath = this.apiURL + '/DeleteHazardMaster/' + HazardMasterId;               
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

        return this.http.get<number>(fullAPIPath, httpOptions)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response | any) {
        debugger;
        console.error(error.message || error);
        return Observable.throw(error.status)
    }
}